<template>
  <div>
    <div class="terms-and-conditions">
      <iframe
        src="https://www.iubenda.com/terms-and-conditions/43113518"
        title="Swampum terms and conditions"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "IframeTerms",
};
</script>

<style lang="scss" scoped>
.terms-and-conditions {
  margin-left: auto;
  margin-right: auto;
  max-width: 800px;

  iframe {
    width: 100%;
    padding-top: 80px;
    height: calc(99vh);
    border: 0;
  }
}
</style>
